<template>
    <div>

       	<div class="page-header" :class="{ 'active' : showPageHeader }">

    		<div class="container-fluid">
    			<div class="page-title">{{ pageTitle }}</div>
    		</div>

    	</div>

    	<div class="page-body pt-0">

    		<div class="cover-image">
          
                <picture style="object-position: top left;">
                  <source srcset="/images/company-portal/image-default.webp" type="image/webp">
                  <source srcset="/images/company-portal/image-default.jpg" type="image/jpg"> 
                  <img src="/images/company-portal/image-default.jpg" style="object-position: top left;">
                </picture>

            </div>

    		<div class="container-fluid">
    			<h1 class="mb-4">{{ pageTitle }}</h1>
    			<p class="mb-12" style="max-width: 700px;">Här har vi samlat frågor och svar. Hittar du inte svaret?<br>Hör av dig till oss på <a href="mailto:support@halsoresurs.se">support@halsoresurs.se</a> så hjälper vi till.</p>
            </div>

            <div class="faq-list" v-if="questions">

                <div class="faq-list-item" :class="{ 'active' : activeQuestion === question.id }" :key="'q'+question.id" v-for="question in questions">
                    <div class="container-fluid">

                        <div class="question" @click="setActiveQuestion(question.id)">
                            <h4>{{ question.title }}</h4>
                            <div class="fold-icon"></div>
                        </div>

                        <div class="answer">
                            <p class="mb-0">
                                {{ question.answer }}
                            </p>
                        </div>

                    </div>
                </div>

            </div>

            <div class="faq-list" v-else>

                test

            </div>

    	</div>

    </div>
</template>

<script>
import fetcher from '../../../shared/mixins/fetcher'
import scrollMixin from '../../../shared/mixins/scrollMixin'

export default {

    mixins: [
        fetcher,
        scrollMixin
    ],

    components: {
    },

    data () {
        return {
            pageTitle: 'Frågor & svar',
            showPageHeader: false,
            activeQuestion: 0,

            questions: [],
            fetcher: {
                autoFill: [
                    'questions'
                ]
            }
        }
    },

    computed: {
        fetcherUrl () {
            return '/data/faq'
        }
    },

    methods: {

        setActiveQuestion (question) {
            if (this.activeQuestion == question) {
                this.activeQuestion = 0
            } else {
                this.activeQuestion = question
            }
        }

    }
}
</script>
